import { render, staticRenderFns } from "./UnboxHeaderBox.vue?vue&type=template&id=1df90c70&scoped=true"
import script from "./UnboxHeaderBox.vue?vue&type=script&lang=js"
export * from "./UnboxHeaderBox.vue?vue&type=script&lang=js"
import style0 from "./UnboxHeaderBox.vue?vue&type=style&index=0&id=1df90c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df90c70",
  null
  
)

export default component.exports